import {
  ASSIGMENTS_ORDER_UPLOAD_DOCUMENT,
  ASSIGMENTS_ORDER_UPLOAD_DOCUMENT_ERROR,
} from '_models/redux/types';
import axios from 'axios';

export const orderAssignmentUploadDocumentAction = (params) => async (dispatch) => {
  const { upload_url, file, content_type } = params || {};

  try {
    // Instancia de axios sin interceptores ni headers globales
    const uploadClient = axios.create();

    const response = await uploadClient.put(upload_url, file, {
      headers: {
        'Content-Type': content_type || file?.type || 'application/pdf',
      },
      transformRequest: [(data) => data], // evita que axios toque el body
    });

    const { data, status } = response || {};

    dispatch({
      method: 'put',
      payload: data || {},
      status: status || {},
      type: ASSIGMENTS_ORDER_UPLOAD_DOCUMENT,
    });

    return data || {};
  } catch (e) {
    dispatch({
      method: 'put',
      payload: e || {},
      type: ASSIGMENTS_ORDER_UPLOAD_DOCUMENT_ERROR,
    });
    throw e;
  }
};
